import React, { useEffect, useState } from "react";
import { Row, Col, Name1, BaseTreeSelector, Button, LucideIcon, Label, Input, useCRUDController, message, fillCanvasElementWithResponse, DeleteButton, Spin } from "./ot";
import RenderFillComponent from "./render_fill_component";
import { transformFormColumnDataToResponseFormValueData } from "./ot";
const canvasElementToTreeData = ({ levelType, elements = [], response_id, parent_response_id }) => {
    let treeData = []
    if (levelType === "display") {
        elements?.forEach((ele) => {
            let form_form_column_data = ele?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data?.find((_) => true)
            if (form_form_column_data_first?.code === "名稱") {
                treeData.push({
                    "id": response_id,
                    "valueKey": levelType,
                    "showCheckbox": false,
                    "label": Array.isArray(ele?.content) ? ele?.content.join(", ") : ele?.content || "",
                    "value": ele?.id,
                    response_id: response_id,
                    parent_response_id: parent_response_id
                })
            }
        })
    }
    else if (levelType === "set") {
        elements?.forEach((ele) => {
            let form_form_column_data = ele?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data?.find((_) => true)
            if (form_form_column_data_first?.code === "題組名稱") {
                treeData.push({
                    "id": response_id,
                    "valueKey": levelType,
                    "showCheckbox": false,
                    "label": Array.isArray(ele?.content) ? ele?.content.join(", ") : ele?.content || "",
                    "value": ele?.id,
                    response_id: response_id,
                    parent_response_id: parent_response_id
                })
            }
        })
    }
    else if (levelType === "topic") {
        let titleContent = "";
        let scoreContent = "";
        let elementId = "";

        elements?.forEach((ele) => {
            let form_form_column_data = ele?.form_form_column_data || []
            let form_form_column_data_first = form_form_column_data?.find((_) => true)

            if (form_form_column_data_first?.code === "題目名稱") {
                titleContent = Array.isArray(ele?.content) ? ele?.content.join(", ") : ele?.content || "";
                elementId = ele?.id; // 保存 id
            }
            else if (form_form_column_data_first?.code === "配分") {
                scoreContent = ele?.content || "";
            }
        });

        // 只有在找到題目名稱時才創建節點
        if (titleContent) {
            treeData.push({
                "id": response_id,
                "valueKey": levelType,
                "showCheckbox": false,
                "label": `${titleContent}${scoreContent ? `（${scoreContent} 分）` : ""}`,
                "value": elementId,
                response_id: response_id,
                parent_response_id: parent_response_id
            })
        }
    }
    return treeData
}
const updateTreeDataByParentId = (allTreeData, newTreeData) => {
    // 如果沒有新數據，直接返回原始數據
    if (!Array.isArray(newTreeData) || newTreeData.length === 0) {
        return allTreeData;
    }
    // 使用 Map 來存儲所有節點，以 response_id 為 key
    const resultMap = new Map();
    // 先加入所有原有數據
    allTreeData.forEach(item => {
        resultMap.set(item.response_id, item);
    });
    // 加入或更新新數據
    newTreeData.forEach(item => {
        resultMap.set(item.response_id, item);
    });
    // 轉回陣列
    return Array.from(resultMap.values());
};
const buildTreeFromFlatData = (flatData) => {
    // 如果沒有數據，返回空陣列
    if (!Array.isArray(flatData) || flatData.length === 0) {
        return [];
    }

    // 用 Map 來存儲所有節點，方便查找
    const nodeMap = new Map();

    // 找到所有根節點（沒有 parent_response_id 的節點）
    const rootNodes = [];

    // 第一次遍歷：建立所有節點的基本結構
    flatData.forEach(node => {
        const treeNode = {
            ...node,
            children: []
        };
        nodeMap.set(node.response_id, treeNode);

        // 如果沒有 parent_response_id，則為根節點
        if (!node.parent_response_id) {
            rootNodes.push(treeNode);
        }
    });

    // 第二次遍歷：建立父子關係
    flatData.forEach(node => {
        if (node.parent_response_id) {
            const parentNode = nodeMap.get(node.parent_response_id);
            if (parentNode) {
                // 將當前節點添加到父節點的 children 中
                parentNode.children.push(nodeMap.get(node.response_id));
            }
        }
    });

    return rootNodes;
};
/**
 * Replace elements' form_form_column_data in content by matching entries from document_form_data
 * @param {Array} content - pages array (如 prompt 中的 content)
 * @param {Array} document_form_data - document_form_data 陣列（每項包含 form_form_column_data）
 * @returns {Array} newContent - 回傳新的 content（不 mutate 原始）
 */
function replaceFormFormColumnData(content = [], document_form_data = []) {
    // 建立以 form_column_id 為 key 的 lookup map（合併所有 document_form_data 的 form_form_column_data）
    const lookup = new Map();
    (document_form_data || []).forEach(doc => {
        const cols = doc?.form_form_column_data || [];
        cols.forEach(col => {
            if (col?.form_column_id != null) {
                lookup.set(Number(col.form_column_id), col);
            }
        });
    });

    // 深拷貝並替換
    const newContent = (content || []).map(page => {
        const newPage = { ...page };
        newPage.elements = (page.elements || []).map(element => {
            const newElement = { ...element };
            const oldCols = element?.form_form_column_data;
            if (Array.isArray(oldCols)) {
                newElement.form_form_column_data = oldCols.map(col => {
                    const id = col?.form_column_id != null ? Number(col.form_column_id) : undefined;
                    // 若 lookup 有對應的欄位資料，使用 document_form_data 的資料；否則保留原本的 col
                    return id != null && lookup.has(id) ? lookup.get(id) : col;
                });
            }
            return newElement;
        });
        return newPage;
    });

    return newContent;
}

const PreviewExam = (
    // 通用更新 canvasElement 的 function
    {
        mainDocumentApiRoute = '/firm_management/backend/display_document/overview',//
        setDocumentApiRoute = '/firm_management/backend/set_document/overview',//
        topicDocumentApiRoute = '/firm_management/backend/topic_document/overview',//
        response_id,
        document_id,
        documentValue,
        propsDocumentValue = false,
        saveCount = 0,
        setSaveCount = () => { },
        onFinish = () => {

        }
    }
) => {

    // minimal local state and safe stubs so component renders without runtime errors
    const [canvasElement, setCanvasElement] = useState([]); //可以定義為defaultCanvasElement的值
    const [documentIdSet, setDocumentIdSet] = useState(null); //可以定義為defaultCanvasElement的值
    const [documentIdTopic, setDocumentIdTopic] = useState(null); //可以定義為defaultCanvasElement的值
    const [allResponseData, setAllResponseData] = useState([]); //可以定義為defaultCanvasElement的值
    const [allTreeData, setAllTreeData] = useState([]); //可以定義為defaultCanvasElement的值

    const [viewMode, setViewMode] = useState('edit')
    const [loading, setLoading] = useState(false)
    const [currentExam, setCurrentExam] = useState({
        id: 'exam1',
        name: '示範評估表',
        examType: 'scored',
        groups: [{
            id: 'g1',
            name: '示範題組',
            questions: [{ id: 'q1', title: '示範題目', score: 10, description: '' }]
        }]
    })
    // const [saveCount, setSaveCount] = useState(0)


    // 通用更新 canvasElement 的 function
    const propsUpdateCanvasElement = ({ element, key, value }) => {
        setCanvasElement((prevPages) => {
            let temp = prevPages.map((page) => {
                return {
                    ...page,
                    elements: page.elements?.map((el) => {
                        if (el?.id === element?.id) {
                            return {
                                ...el,
                                [key]: value
                            }
                        }
                        return el;
                    })
                }
            })
            return temp
        })
    }
    const validatePercentages = (exam) => ({ total: true, isValid: true, message: '權重合計正常' })
    const SimplePreview = ({ exam }) => (
        <div className="p-4 border rounded bg-white">
            <h3 className="font-semibold">預覽：{exam?.name || '無名稱'}</h3>
            <p className="text-sm text-gray-600">題組數：{(exam?.groups || []).length}</p>
        </div>
    )
    const onSetDelete = (response_id) => {
        responseController.deleteData([
            {
                response_id
            }
        ])
        if (response_id) {
            setCanvasElement((prevPages) => {
                let temp = prevPages.map((page) => {
                    const updatedElements = page?.elements.map((item) => {
                        if (item?.type === "set") {
                            let content = item?.content || []
                            content = content.filter((ele) => ele !== response_id)
                            return {
                                ...item,
                                content: content
                            };
                        }
                        else {
                            return item;
                        }
                    });
                    return {
                        ...page,
                        elements: updatedElements,
                    };
                })
                return temp
            });
        }
    }
    const onSave = () => {
        onDocumentSubmit({
            response_id,
            document_id: document_id,
            form_column_data: buildFormColumnData(canvasElement),
            responseController: responseMainController
        })
    }
    const displayApiController = useCRUDController({
        apiRoute: mainDocumentApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })
    const setApiController = useCRUDController({
        apiRoute: setDocumentApiRoute,
        onBefore: () => { },
        onFinish: () => { }
    })
    const topicApiController = useCRUDController({
        apiRoute: topicDocumentApiRoute,
        onBefore: () => { },
        onFinish: () => { }
    })
    const responseController = useCRUDController({
        apiRoute: "/utility/response/cache",
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")
                    setCanvasElement((prevPages) => {
                        let temp = prevPages.map((page) => {
                            const updatedElements = page?.elements.map((item) => {
                                if (item?.type === "set") {
                                    let content = item?.content || []
                                    content.push(values?.response_id)
                                    return {
                                        ...item,
                                        content: content

                                    };
                                }
                                else {
                                    return item;
                                }
                            });
                            return {
                                ...page,
                                elements: updatedElements,
                            };

                        })
                        return temp
                    });

                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
            }
        }
    })
    const responseMainController = useCRUDController({
        apiRoute: "/utility/response/cache",
        onBefore: ({ axiosMode }) => {
            if (axiosMode === "get") {
                console.log({
                    loading :1
                })
                setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
            onFinish({ axiosMode, status, values })
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功")


                } else if (axiosMode === "patch") {
                    message.success("修改成功")
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功")

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗")

                }
                else if (axiosMode === "patch") {
                    message.error("修改失敗")
                }
                else if (axiosMode === "delete") {
                    message.error("刪除失敗")
                }
            }
            if (axiosMode === "get") {
                setLoading(false)
            }
        }
    })
    const onTreeNodeChange = (newTreeData) => {
        setAllTreeData((prevTreeData) => updateTreeDataByParentId(prevTreeData, newTreeData));
    };
    useEffect(() => {
        // If documentValue is provided, use it directly and do not fetch
        if (!!documentValue) {
            let dataFirst = documentValue;
            let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
            // let all_form_form_column_data = document_form_data?.[0]?.form_form_column_data ?? []
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
            let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
            let canvas_content = document_x_canvas_content_first?.content || []

            let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
            canvas_content = replaceFormFormColumnData(canvas_content, document_form_data)
            setCanvasElement(canvas_content)
            let newData = fillCanvasElementWithResponse(canvas_content, [])
            newData?.forEach((page) => {
                page?.elements?.filter((element) => element?.type === "set")
                    ?.forEach((element) => {
                        let form_column_id = element?.form_column_id
                        let form_form_column_data = element?.form_form_column_data
                        let form_form_column_data_first = form_form_column_data?.find((_) => true)
                        let form_column_source_data = form_form_column_data_first?.form_column_source_data
                        let form_column_source_data_first = form_column_source_data?.find((_) => true)
                        let document_id = form_column_source_data_first?.document_id
                        setDocumentIdSet(document_id)
                    })
            });
            setCanvasElement(newData)
            return;
        }
        // If no document_id, do not fetch
        if (!document_id || propsDocumentValue) return;
        displayApiController.getData({
            document_id
        }).then((res) => {
            let data = res?.data
            let dataFirst = data?.find((_) => true)
            let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
            let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
            // let all_form_form_column_data = document_form_data?.[0]?.form_form_column_data ?? []
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
            let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
            let canvas_content = document_x_canvas_content_first?.content || []
            canvas_content = replaceFormFormColumnData(canvas_content, document_form_data)
            // setCanvasElement(newData)
            let newData = fillCanvasElementWithResponse(canvas_content, [])


        })
    }, [mainDocumentApiRoute, document_id, documentValue])
    useEffect(() => {
        if (response_id) {
            responseMainController.getData({
                response_id: response_id
            })
        }

    }, [response_id])
    useEffect(() => {
        let responseValue = responseMainController?.ResponseData.find((_) => true)
        setAllResponseData((pre) => {
            let temp = [...pre]
            temp = temp.filter((ele) => {
                return ele?.response_id === responseValue?.response_id
            })
            temp.push(responseValue)
            return temp
        })
        if (responseValue?.response_form_value_data && Array.isArray(canvasElement) && canvasElement.length > 0) {
            setCanvasElement((prev) => {
                let newData = fillCanvasElementWithResponse(prev, responseValue?.response_form_value_data)
                newData?.forEach((page) => {
                    page?.elements?.filter((element) => element?.type === "set")
                        ?.forEach((element) => {
                            let form_form_column_data = element?.form_form_column_data
                            let form_form_column_data_first = form_form_column_data?.find((_) => true)
                            let form_column_source_data = form_form_column_data_first?.form_column_source_data
                            let form_column_source_data_first = form_column_source_data?.find((_) => true)
                            let document_id = form_column_source_data_first?.document_id
                            setDocumentIdSet(document_id)
                        })
                });

                return newData
            });
        }
    }, [responseMainController?.ResponseData, canvasElement.length]);
    useEffect(() => {
        if (documentIdSet) {
            setApiController.getData({ document_id: documentIdSet })
                .then((res) => {
                    let data = res?.data
                    let dataFirst = data?.find((_) => true)
                    let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
                    let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
                    let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
                    let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
                    let canvas_content = document_x_canvas_content_first?.content || []
                    // let newData = fillCanvasElementWithResponse(canvas_content, [])
                    canvas_content?.forEach((page) => {
                        page?.elements?.filter((element) => element?.type === "topic")
                            ?.forEach((element) => {
                                let form_form_column_data = element?.form_form_column_data
                                let form_form_column_data_first = form_form_column_data?.find((_) => true)
                                let form_column_source_data = form_form_column_data_first?.form_column_source_data
                                let form_column_source_data_first = form_column_source_data?.find((_) => true)
                                let document_id = form_column_source_data_first?.document_id
                                setDocumentIdTopic(document_id)
                            })
                    });
                })
        }
    }, [documentIdSet])
    useEffect(() => {
        if (documentIdTopic) {
            topicApiController.getData({ document_id: documentIdTopic })
        }
    }, [documentIdTopic])
    useEffect(() => {
        if (saveCount && saveCount !== 0) {
            onSave()
        }
    }, [saveCount])
    useEffect(() => {
        // let treeData = canvasElementToTreeData({
        //     levelType: "display",
        //     elements: canvasElement?.[0]?.elements || [],
        //     response_id,
        //     // parent_response_id
        // })
        // onTreeNodeChange(treeData)
    }, [canvasElement])
    useEffect(() => {
        console.log({
            allTreeData
        })

    }, [allTreeData])
    return (
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 xl:gap-6">
            <div className="lg:col-span-1 lg:sticky lg:top-4 self-start">
                <BaseTreeSelector
                    title="題目結構"
                    showCheckbox={false}
                    data={buildTreeFromFlatData(allTreeData)}
                />
            </div>
            <div className="lg:col-span-3">
                {/* 右上角：小螢幕下的模式切換 */}
                <div className="flex items-center gap-2 justify-end mb-3 lg:mb-1">
                    <Button
                        type="primary"
                        onClick={() => {
                            setSaveCount((pre) => {
                                return pre + 1
                            })
                        }}
                    >
                        儲存
                    </Button>
                    {response_id &&
                        <DeleteButton
                            onConfirm={() => {
                                responseMainController.deleteData(
                                    [{ response_id: response_id }]
                                )
                            }}
                        />}

                    <Button
                        variant={viewMode === 'edit' ? 'default' : 'outline'}
                        className={viewMode === 'edit' ? 'bg-blue-600 hover:bg-blue-700' : ''}
                        onClick={() => setViewMode('f')}
                    >
                        編輯
                    </Button>

                    <Button
                        variant={viewMode === 'preview' ? 'default' : 'outline'}
                        className={viewMode === 'preview' ? 'bg-gray-800 hover:bg-gray-900' : ''}
                        onClick={() => setViewMode('preview')}
                    >
                        預覽
                    </Button>
                    {/* <Button variant="outline"  >
                        <LucideIcon name="Download" className="h-4 w-4 mr-1" />
                        匯出{currentExam?.name ? ` - ${currentExam.name}` : ''}
                    </Button> */}
                </div>
                <Spin spinning={loading} >
                    {viewMode === 'preview' ? (
                        <SimplePreview exam={currentExam} />
                    ) : (
                        <>
                            {/* 績效評估表層級設定：類型與整體計分方式 */}
                            <div className="p-4 bg-gray-50/50 border rounded-lg space-y-3 mb-3">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                    <DocumentRender
                                        propsCanvasElement={canvasElement}
                                        documentValue={displayApiController?.ResponseData?.find((_) => true)}
                                        apiRoute={mainDocumentApiRoute}
                                        renderFilter={element => element?.type !== "set"}
                                        renderComponent={(element,) => (
                                            <RenderFillComponent
                                                key={element?.id}
                                                element={element}
                                                updateElementContent={(element, val) => {
                                                    propsUpdateCanvasElement({ element, key: "content", value: val })
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            {
                                canvasElement?.map((page) => {
                                    return page?.elements?.filter((element) => element?.type === "set")
                                        ?.map((element) => {
                                            let form_form_column_data = element?.form_form_column_data || []
                                            let form_form_column_data_first = form_form_column_data?.find((_) => true)
                                            let form_column_source_data = form_form_column_data_first?.form_column_source_data
                                            let form_column_source_data_first = form_column_source_data?.find((_) => true)
                                            let document_id = form_column_source_data_first?.document_id
                                            let content = Array.isArray(element?.content) ? element?.content : [] //題組的response_id

                                            return (
                                                <>
                                                    <div className="flex items-center justify-between p-4 bg-gray-50/50 border rounded-lg">
                                                        <div className="flex items-center gap-3">
                                                            <Button variant="default"
                                                                onClick={() => {
                                                                    onDocumentSubmit({
                                                                        document_id: document_id,
                                                                        form_column_data: form_form_column_data,
                                                                        responseController
                                                                    })
                                                                }}
                                                                className="bg-blue-600 hover:bg-blue-700">
                                                                <LucideIcon name="Plus" className="h-4 w-4 mr-2" />
                                                                新增題組
                                                            </Button>
                                                            <span className="text-sm text-gray-600">點擊新增題組來擴展評估架構</span>
                                                        </div>
                                                        {/* 用來計算分數是否合理的參數 */}
                                                        {currentExam?.examType === 'scored' && (() => {
                                                            const validation = validatePercentages(currentExam)
                                                            if (!validation.total) return null
                                                            return (
                                                                <div className={`px-3 py-2 rounded-md text-sm ${validation.isValid
                                                                    ? 'bg-green-50 text-green-700 border border-green-200'
                                                                    : 'bg-yellow-50 text-yellow-700 border border-yellow-200'
                                                                    }`}>
                                                                    <div className="flex items-center gap-2">
                                                                        <LucideIcon name={validation.isValid ? "CheckCircle" : "AlertTriangle"} className="w-4 h-4" />
                                                                        {validation.message}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    {
                                                        (content || []).map((response_id_set, index) => {
                                                            return <SetDocumentRender
                                                                key={index}
                                                                documentValue={setApiController?.ResponseData.find((_) => true)}
                                                                document_id={document_id}
                                                                response_id={response_id_set}
                                                                parent_response_id={response_id}
                                                                setDocumentApiRoute={setDocumentApiRoute}
                                                                onDelete={onSetDelete}
                                                                documentIdTopic={documentIdTopic}
                                                                topicDocumentValue={topicApiController?.ResponseData.find((_) => true)}
                                                                topicDocumentApiRoute={topicDocumentApiRoute}
                                                                saveCount={saveCount}
                                                                onTreeNodeChange={onTreeNodeChange}
                                                            />
                                                        })
                                                    }
                                                </>
                                            )
                                        })
                                })
                            }

                        </>
                    )}
                </Spin>

            </div>
        </div>
    )
}

// 題組
const SetDocumentRender = ({
    setDocumentApiRoute,
    canDelete = true,
    response_id,   //set 的
    // parent_response_id,
    document_id = 1251, //set 的
    topicDocumentApiRoute = '/firm_management/backend/topic_document/overview',
    responseApiRoute = "/utility/response/cache",
    propsDocumentValue,
    documentValue,

    documentIdTopic,
    topicDocumentValue,
    saveCount,
    onTreeNodeChange = () => { },
    onDelete = () => {

    }

}) => {
    const [canvasElement, setCanvasElement] = useState([]); //可以定義為defaultCanvasElement的值
    const propsUpdateCanvasElement = ({ element, key, value }) => {
        setCanvasElement((prevPages) => {
            let temp = prevPages.map((page) => {
                return {
                    ...page,
                    elements: page.elements?.map((el) => {
                        if (el?.id === element?.id) {
                            return {
                                ...el,
                                [key]: value
                            }
                        }
                        return el;
                    })
                }
            })
            return temp
        })
    }
    const onSave = () => {
        onDocumentSubmit({
            response_id,
            document_id: document_id,
            form_column_data: buildFormColumnData(canvasElement),
            responseController
        })
    }
    const responseController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        setCanvasElement((prevPages) => {
                            let temp = prevPages.map((page) => {
                                const updatedElements = page?.elements.map((item) => {
                                    if (item?.type === "topic") {
                                        let content = Array.isArray(item?.content) ? item?.content : []
                                        content.push(values?.response_id)

                                        return {
                                            ...item,
                                            content: content

                                        };
                                    }
                                    else {
                                        return item;
                                    }
                                });
                                return {
                                    ...page,
                                    elements: updatedElements,
                                };

                            })
                            return temp
                        });
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                    }
                }
            },
            onBefore: () => { },
            apiRoute: responseApiRoute,
        });
    const onTopicDelete = (response_id) => {
        responseController.deleteData([
            {
                response_id
            }
        ])
        if (response_id) {
            setCanvasElement((prevPages) => {
                let temp = prevPages.map((page) => {
                    const updatedElements = page?.elements.map((item) => {
                        if (item?.type === "topic") {
                            let content = item?.content || []
                            content = content.filter((ele) => ele !== response_id)
                            return {
                                ...item,
                                content: content
                            };
                        }
                        else {
                            return item;
                        }
                    });
                    return {
                        ...page,
                        elements: updatedElements,
                    };
                })
                return temp
            });
        }
    }
    useEffect(() => {
        if (saveCount && saveCount !== 0) {
            onSave()
        }
    }, [saveCount])
    useEffect(() => {
        if (!!documentValue) {
            let dataFirst = documentValue
            let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
            let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
            let canvas_content = document_x_canvas_content_first?.content || []
            let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
            canvas_content = replaceFormFormColumnData(canvas_content, document_form_data)
            setCanvasElement(canvas_content)
        }
    }, [documentValue])

    useEffect(() => {
        responseController.getData({
            response_id: response_id
        })
    }, [response_id])
    useEffect(() => {
        let responseValue = responseController?.ResponseData.find((_) => true)
        // setAllResponseData((pre) => {
        //     let temp = [...pre]
        //     temp = temp.filter((ele) => {
        //         return ele?.response_id === responseValue?.response_id
        //     })
        //     temp.push(responseValue)
        //     return temp
        // })
        if (responseValue?.response_form_value_data && Array.isArray(canvasElement) && canvasElement.length > 0) {
            setCanvasElement((prev) => {

                let newData = fillCanvasElementWithResponse(prev, responseValue?.response_form_value_data)
                // newData?.forEach((page) => {
                //     page?.elements?.filter((element) => element?.type === "topic")
                //         ?.forEach((element) => {
                //             let form_form_column_data = element?.form_form_column_data
                //             let form_form_column_data_first = form_form_column_data?.find((_) => true)
                //             let form_column_source_data = form_form_column_data_first?.form_column_source_data
                //             let form_column_source_data_first = form_column_source_data?.find((_) => true)
                //             let document_id = form_column_source_data_first?.document_id
                //         })
                // });

                return newData
            });
        }
    }, [responseController?.ResponseData, canvasElement.length]);
    useEffect(() => {
        let treeData = canvasElementToTreeData({
            levelType: "set",
            elements: canvasElement?.[0]?.elements || [],
            response_id,
            // parent_response_id
        })
        onTreeNodeChange(treeData)
    }, [canvasElement])
    return (
        <div className="rounded-lg border border-blue-200 bg-white shadow-sm overflow-hidden mb-4">
            {/* 題組編輯區 */}
            <div className="p-3 sm:p-4 space-y-3 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-indigo-50">
                {/* 題組標題與刪除按鈕 */}
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center">
                            <LucideIcon name="Folder" className="h-3 w-3 text-white" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900">題組設定</h3>
                    </div>
                    {canDelete && (
                        <Button
                            onClick={() => {
                                onDelete(response_id)
                            }}
                            variant="ghost" size="sm" className="text-red-600 hover:bg-red-50 text-xs py-1 px-2 h-7">
                            <LucideIcon name="Trash2" className="h-3 w-3 mr-1" />
                            刪除
                        </Button>
                    )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                    <DocumentRender
                        propsCanvasElement={canvasElement}
                        response_id={response_id}
                        document_id={document_id}
                        documentValue={documentValue}
                        apiRoute={setDocumentApiRoute}
                        renderFilter={element => element?.type !== "topic"}
                        renderComponent={(element, updateCanvasElement) => (
                            <RenderFillComponent
                                key={element?.id}
                                element={element}
                                updateElementContent={(element, val) => {
                                    propsUpdateCanvasElement({ element, key: "content", value: val })
                                }}
                            />
                        )}
                    />
                </div>
            </div>
            {/* 題目編輯清單 */}
            <div className="p-3 sm:p-4 space-y-2 bg-gray-50/30">
                <div className="flex items-center gap-2 mb-2">
                    <LucideIcon name="List" className="h-4 w-4 text-green-600" />
                    <h4 className="text-sm font-semibold text-gray-800">題目清單</h4>
                    <div className="flex-1 h-px bg-gradient-to-r from-green-200 to-transparent"></div>
                </div>
                {
                    canvasElement?.map((page) => {
                        return page?.elements?.filter((element) => element?.type === "topic")
                            ?.map((element) => {
                                let form_form_column_data = element?.form_form_column_data || []
                                let form_form_column_data_first = form_form_column_data?.find((_) => true)
                                let form_column_source_data = form_form_column_data_first?.form_column_source_data
                                let form_column_source_data_first = form_column_source_data?.find((_) => true)
                                let document_id = form_column_source_data_first?.document_id
                                let content = Array.isArray(element?.content) ? element?.content : [] //題組的response_id
                                return (
                                    <>
                                        <div className="flex justify-center pt-2">
                                            <Button variant="outline" size="sm" className="border-green-300 text-green-700 hover:bg-green-50 text-xs py-1 px-2 h-7"
                                                onClick={() => {
                                                    onDocumentSubmit({
                                                        document_id: document_id,
                                                        form_column_data: form_form_column_data,
                                                        responseController
                                                    })
                                                }}
                                            >
                                                <LucideIcon name="Plus" className="h-3 w-3 mr-1" />
                                                新增題目
                                            </Button>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                            {
                                                (content || []).map((response_id_topic, index) => {
                                                    return (
                                                        <TopicDocumentRender
                                                            saveCount={saveCount}
                                                            key={index}
                                                            index={index}
                                                            topicDocumentApiRoute={topicDocumentApiRoute}
                                                            parent_response_id={response_id}
                                                            response_id={response_id_topic}
                                                            documentValue={topicDocumentValue}
                                                            document_id={documentIdTopic}
                                                            onDelete={onTopicDelete}
                                                            onTreeNodeChange={onTreeNodeChange}

                                                        />
                                                    )
                                                })
                                            }
                                        </div>
                                    </>
                                )
                            })
                    })
                }

                {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    {[1091, 1092, 1093, 1094, 1095, 111].map((value, index) => {
                        return (<TopicDocumentRender
                            key={index}
                            index={index}
                            topicDocumentApiRoute={topicDocumentApiRoute}
                            response_id={value}
                            documentValue={topicDocumentValue}
                        />)
                    })}
                </div> */}
            </div>
        </div>
    )
}
// 題目
const TopicDocumentRender = ({
    topicDocumentApiRoute = '/firm_management/backend/topic_document/overview',
    q,
    index,
    currentExam,
    document_id = 1251,
    response_id = 1091,
    parent_response_id,
    documentValue,
    propsDocumentValue = true,
    onTreeNodeChange = () => { },
    onDelete = () => { },
    saveCount
}) => {
    const [tempData, setTempData] = useState(null)
    const apiController = useCRUDController({
        apiRoute: topicDocumentApiRoute,
        onBefore: () => { },
        onFinish: () => { }
    })
    const responseController = useCRUDController({
        apiRoute: "/utility/response/cache",
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {

        }
    })
    const onSave = () => {
        onDocumentSubmit({
            response_id,
            document_id: document_id,
            form_column_data: buildFormColumnData(tempData),
            responseController
        })
    }
    useEffect(() => {
        if (saveCount && saveCount !== 0) {
            onSave()
        }
    }, [saveCount])
    useEffect(() => {
        let treeData = canvasElementToTreeData({
            levelType: "topic",
            elements: tempData?.[0]?.elements || [],
            response_id,
            parent_response_id,
        })
        onTreeNodeChange(treeData)
    }, [tempData])
    return (
        <div key={q?.id} className="h-full rounded-lg border border-green-200 bg-white p-2 sm:p-3 space-y-2 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center gap-2 mb-2">
                <div className="w-5 h-5 rounded-full bg-green-600 text-white text-xs flex items-center justify-center font-semibold">
                    {index + 1}
                </div>
                <span className="text-xs font-medium text-green-700">題目 {index + 1}</span>
                <Button
                    onClick={() => {
                        onDelete(response_id)
                    }}
                    variant="ghost" size="sm" className="text-red-600 hover:bg-red-50 text-xs py-1 px-2 h-6 ml-auto">
                    <LucideIcon name="Trash2" className="h-3 w-3 mr-1" />
                    刪除
                </Button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
                <DocumentRender
                    onChange={(value) => {
                        setTempData(value)
                    }}
                    documentValue={documentValue}
                    response_id={response_id}
                    apiRoute={topicDocumentApiRoute}
                    renderFilter={element => element?.type !== "set"}
                    renderComponent={(element, updateCanvasElement) => (
                        <RenderFillComponent
                            key={element?.id}
                            element={element}
                            updateElementContent={(element, val) => {
                                updateCanvasElement({ element, key: "content", value: val })
                            }}
                        />
                    )}
                />
            </div>
        </div>
    )
}
// DocumentRender 只負責資料渲染，不包裝任何 div/標題/按鈕
const DocumentRender = ({
    apiRoute,
    renderFilter,
    renderComponent,
    response_id,
    document_id,
    documentValue,
    propsDocumentValue = true,
    propsCanvasElement,
    onChange = () => { }
}) => {
    const [canvasElement, setCanvasElement] = useState([])
    const apiController = useCRUDController({
        apiRoute,
        onBefore: () => { },
        onFinish: () => { }
    })
    const responseController = useCRUDController({
        apiRoute: "/utility/response/cache",
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {

        }
    })
    const updateCanvasElement = ({ element, key, value }) => {
        setCanvasElement((prevPages) => {
            let temp = prevPages.map((page) => {
                return {
                    ...page,
                    elements: page.elements?.map((el) => {
                        if (el?.id === element?.id) {
                            return {
                                ...el,
                                [key]: value
                            }
                        }
                        return el;
                    })
                }
            })
            return temp
        })
    }
    useEffect(() => {
        // If documentValue is provided, use it directly and do not fetch
        if (documentValue) {
            let dataFirst = documentValue;
            let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
            let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
            let canvas_content = document_x_canvas_content_first?.content || []
            let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
            canvas_content = replaceFormFormColumnData(canvas_content, document_form_data)
            setCanvasElement(canvas_content)
            return;
        }
        // If no document_id, do not fetch
        if (!document_id || !propsDocumentValue) return;
        apiController.getData({
            document_id
        }).then((res) => {
            let data = res?.data
            let dataFirst = data?.find((_) => true)
            let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
            let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
            let canvas_content = document_x_canvas_content_first?.content || []
            setCanvasElement(canvas_content)
        })
    }, [apiRoute, document_id, documentValue])
    useEffect(() => {
        responseController.getData({
            response_id: response_id
        })
    }, [response_id])
    useEffect(() => {

        let responseValue = responseController?.ResponseData.find((_) => true)
        if (responseValue?.response_form_value_data && Array.isArray(canvasElement) && canvasElement.length > 0) {
            setCanvasElement((prev) => {
                let newData = fillCanvasElementWithResponse(prev, responseValue?.response_form_value_data)
                return newData
            });
        }
    }, [responseController?.ResponseData, canvasElement.length]);
    useEffect(() => {
        onChange(canvasElement)
    }, [canvasElement])
    return (
        <>
            {(propsCanvasElement ? propsCanvasElement : canvasElement)?.map((page) => (
                page?.elements?.filter(renderFilter)?.map((element) => (
                    <React.Fragment key={element?.id}>
                        {renderComponent(element, updateCanvasElement)}
                    </React.Fragment>
                ))
            ))}
        </>
    )
}
const onDocumentSubmit = ({ response_id, document_id, form_column_data, document_response_data, responseController }) => {
    let postValue = {
        "type": "1",
        "document_response_data": [
            {
                "document_id": document_id
            }
        ],
        "response_form_value_data": [
            // {
            //     "form_column_form_value_data": [
            //         {
            //             "form_column_id": 1
            //         }
            //     ],
            //     "is_option": 1,
            //     "index": 2,
            //     "value": {
            //         "value": [1, 2, 3]
            //     },
            //     "value_type": "selection"
            // }
        ]
    }
    let response_form_value_data = transformFormColumnDataToResponseFormValueData(form_column_data);
    postValue = { ...postValue, response_form_value_data }
    let postData = [
        { ...postValue }
    ]

    let patchValue = {
        "type": 1,
        "response_id": response_id,
        // "document_response_data": document_response_data,
        "response_form_value_data": response_form_value_data
    }
    let patchData = [
        {
            ...patchValue
        }
    ]

    if (response_id) {
        responseController.patchData(patchData)
    }
    else {
        responseController.postData(postData)
    }
}
function buildFormColumnData(tempData) {
    // tempData 是 array
    return tempData?.flatMap(page =>
        (page.elements || []).flatMap(element =>
            (element.form_form_column_data || []).map(col => ({
                ...col,
                content: element?.content,
                value: {
                    value: element?.content
                }
                // 或你要的 key
            }))
        )
    );
}
export default PreviewExam;

